'use client'

import Link from 'next/link'

import { CustomImageBanner } from '@/screens/promo-apipromo/ui/CustomImageBanner/CustomImageBanner'

import { Button } from '@/shared/ui'

import { PROMO_IPHONE_18_IMAGES_URL } from '../assets/images'

import cl from './Sertificate.module.scss'

const block = {
	banners: {
		desktop: {
			src: `${PROMO_IPHONE_18_IMAGES_URL}/banner-2-1440.webp`,
			link: ''
		},
		mobile: {
			src: `${PROMO_IPHONE_18_IMAGES_URL}/banner-21-375.webp`
		},
		tablet: {
			src: `${PROMO_IPHONE_18_IMAGES_URL}/banner-21-768.webp`
		}
	}
}

export const Sertificate = () => {
	return (
		<section className={cl.root}>
			<h2 className={cl.title}>
				Оформите Сертификат и&nbsp;получите новый iPhone 18&nbsp;Pro l&nbsp;Pro Max
				<br /> первыми
			</h2>

			<div className={cl.banner}>
				<CustomImageBanner
					imgAlt=""
					imgSrcDesk={block.banners.desktop.src}
					imgSrcMob={block.banners.mobile.src}
					imgSrcTablet={block.banners.tablet.src}
					imgDeskWidth={1440}
					imgDeskHeight={649}
					imgTabletWidth={768}
					imgTabletHeight={348}
					imgMobWidth={375}
					imgMobHeight={202}
					link={block.banners.desktop.link}
					disabled={!block.banners.desktop.link}
					title=""
					className={cl.bannerImage}
				/>
				<div className={cl.content}>
					<div className={cl.contentTop}>
						<h3 className={cl.contentTitle}>Cертификат на&nbsp;покупку iPhone 18&nbsp;Pro ӏ Pro Max</h3>
						<p className={cl.contentValue}>5&nbsp;000&nbsp;₽</p>
						<Button as={Link} href={`https://www.iport.ru/products/productID156487/`} target="_blank" size="L">
							Купить
						</Button>
					</div>
					<ol className={cl.contentList}>
						<li>Право на&nbsp;приобретение iPhone 18&nbsp;Pro ӏ Pro Max в&nbsp;числе первых.</li>
						<li>Стоимость сертификата (5&nbsp;000&nbsp;₽) идёт в&nbsp;счёт стоимости нового устройства.</li>
						<li>Дополнительная скидка до&nbsp;5&nbsp;000&nbsp;₽ на&nbsp;аксессуары.</li>
						<li>Гарантированный подарок: аксессуар на&nbsp;выбор и&nbsp;установка приложения.</li>
					</ol>
				</div>
			</div>
		</section>
	)
}
